var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mailbox',{attrs:{"name":_vm.mailbox.name,"mailbox-key":_vm.key,"mailbox-slug":_vm.slug,"tickets":_vm.tickets}})}
var staticRenderFns = []

export { render, staticRenderFns }